import React from 'react'
import styled from 'styled-components'
import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const CardContainer = styled(Card)`
  border-radius: 20px;
  box-shadow: 0 6px 26px 0 rgba(0, 0, 0, 0.08);
  text-align: center;
  font-size: 1.125em;
  height: 8em;
  background: #ffffff ${props => `url(${props.image}) no-repeat 50% 20%`};
  background-size: auto;
  transition: 0.4s ease-in-out;
`
const CardTitle = styled.h4`
  line-height: 8em;
`
const ProductLink = styled(Link)`
  color: black;
  &:hover {
    color: black;
    text-decoration: none;
  }
`

export default function Brand(props) {
  const { image, text } = props
  return (
    <Col lg={4} md={6} xs={12} className="md-3 px-2 mb-2">
      <ProductLink to={`/dashboard/products/${text.replace(/ /g, '-')}`}>
        <CardContainer image={image}>
          <Card.Body>
            <CardTitle>{text}</CardTitle>
          </Card.Body>
        </CardContainer>
      </ProductLink>
    </Col>
  )
}
Brand.propTypes = {
  text: PropTypes.string,
  image: PropTypes.string,
  products: PropTypes.array,
}
